"use client"

import styled from "@emotion/styled"
import { useInView } from "react-intersection-observer"
import colors from "theme/colors"
import {
  Container,
  NewText,
  styleObjectToCss,
  transitionDelayTime,
  TransitionUp,
  useInViewConfig,
  useTransitionUpStyles,
} from "ui"
import ImageWithAlt from "ui/ImageWithAlt"
import { delayTime } from "ui/transitions/utils"
import { extractImage, extractProperty } from "utils"

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  text-align: center;
  max-width: 690px;
  margin: auto;
  margin-top: 80px;
  padding-bottom: 112px;
`

const StyledEmailContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
`
type Props = {
  data: any
}

function MediaContact({ data }: Props) {
  const title = extractProperty(data, "title")
  const content = extractProperty(data, "content")
  const image = extractImage(data, "emailIcon")
  const emailAddress = extractProperty(data, "emailAddress")
  const { ref, inView } = useInView(useInViewConfig)
  const imageTransitionStyles = useTransitionUpStyles(inView)
  const descriptionTransitionStyles = useTransitionUpStyles(inView, delayTime)
  return (
    <Container>
      <StyledContainer ref={ref}>
        {title && (
          <NewText
            cssString={styleObjectToCss(imageTransitionStyles)}
            component={"h3"}
            desktopFontSize={40}
            desktopLineHeight={"44px"}
            desktopFontWeight={400}
            mobileFontSize={32}
            mobileLineHeight={"46px"}
            color={colors.black}
          >
            {title}
          </NewText>
        )}
        <NewText
          cssString={styleObjectToCss(descriptionTransitionStyles)}
          component={"p"}
          desktopFontSize={16}
          desktopLineHeight={"23px"}
          mobileFontSize={14}
          mobileLineHeight={"20px"}
          desktopFontWeight={400}
          color={colors.black}
          dangerouslySetInnerHTML={{ __html: content }}
        />
        <a style={{ textDecorationColor: colors.darkGreen }} href={emailAddress?.[0]?.url}>
          <TransitionUp $inView={inView} $delay={transitionDelayTime * 3}>
            <StyledEmailContainer>
              <ImageWithAlt image={image} width={32} height={32} />
              <NewText
                component={"p"}
                desktopFontSize={16}
                desktopLineHeight={"23px"}
                desktopFontWeight={400}
                mobileFontSize={14}
                mobileLineHeight={"20px"}
                color={colors.darkGreen}
              >
                {emailAddress?.[0]?.name}
              </NewText>
            </StyledEmailContainer>
          </TransitionUp>
        </a>
      </StyledContainer>
    </Container>
  )
}

export default MediaContact
